import * as React from 'react';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgBrCircle = function SvgBrCircle(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#093",
        d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#FFD221",
        d: "M23.998 12.115q0 .09-.002.177l-12.235 7.879L.002 12.174 0 12l.001-.09 11.926-8.206z"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_3242_8001)",
        d: "M23.998 12.115q0 .09-.002.177l-12.235 7.879L.002 12.174 0 12l.001-.09 11.926-8.206z"
    })), _path4 || (_path4 = /*#__PURE__*/ React.createElement("path", {
        fill: "#2E42A5",
        fillRule: "evenodd",
        d: "M12 17.2a5 5 0 1 0 0-10 5 5 0 0 0 0 10",
        clipRule: "evenodd"
    })), _path5 || (_path5 = /*#__PURE__*/ React.createElement("path", {
        fill: "#F7FCFF",
        fillRule: "evenodd",
        d: "m10.38 14.57-.223.117.042-.248-.18-.176.25-.037.111-.226.112.226.25.037-.181.176.042.248zM12.38 14.57l-.223.117.042-.248-.18-.176.25-.037.111-.226.112.226.25.037-.181.176.042.248zM12.38 15.77l-.223.117.042-.248-.18-.176.25-.037.111-.226.112.226.25.037-.181.176.042.248zM11.38 11.57l-.223.117.042-.248-.18-.176.25-.037.111-.226.112.226.25.037-.181.176.042.248zM11.38 13.57l-.223.117.042-.248-.18-.176.25-.037.111-.226.112.226.25.037-.181.176.042.248zM9.98 12.57l-.223.117.042-.248-.18-.176.25-.037L9.98 12l.112.226.25.037-.181.176.042.248zM8.58 13.37l-.223.117.042-.248-.18-.176.25-.037.111-.226.112.226.25.037-.181.176.042.248zM13.18 9.97l-.223.117.042-.248-.18-.176.25-.037.111-.226.112.226.25.037-.181.176.042.248z",
        clipRule: "evenodd"
    })), _path6 || (_path6 = /*#__PURE__*/ React.createElement("path", {
        fill: "#F7FCFF",
        d: "M7.984 9.22c3.633.557 6.609 1.901 8.903 4.038a5 5 0 0 1-.673 1.632l-.26.253c-2.143-2.205-5.077-3.547-8.837-4.023.154-.7.454-1.344.867-1.9"
    })), _path7 || (_path7 = /*#__PURE__*/ React.createElement("path", {
        fill: "#093",
        d: "m8.29 10.603.051-.498c3.093.32 5.746 1.505 7.95 3.552l-.34.366q-3.184-2.956-7.662-3.42"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_3242_8001",
        x1: 24,
        x2: 24,
        y1: 24,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFC600"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FFDE42"
    })))));
};

export { SvgBrCircle as ReactComponent };
//# sourceMappingURL=BRCircle.svg.es.js.map
